import IconCircleCheck from "central-icons/IconCircleCheck";
import IconCircleDotted from "central-icons/IconCircleDotted";
import IconCircleX from "central-icons/IconCircleX";
import IconStopCircle from "central-icons/IconStopCircle";
import IconTrashCan from "central-icons/IconTrashCan";
import IconLoadingCircle from "central-icons/IconLoadingCircle";
import type { FC } from "react";
import { ActionGroupType } from "@/utils/automation-execution-action";

type WorkflowExecutionActionGroupIconProps = {
    groupType: ActionGroupType;
};

export const WorkflowExecutionActionGroupIcon: FC<WorkflowExecutionActionGroupIconProps> = ({ groupType }) => {
    switch (groupType) {
        case ActionGroupType.Active:
            return <IconLoadingCircle size={16} className="shrink-0 animate-spin" />;
        case ActionGroupType.Pending:
            return <IconCircleDotted size={16} className="shrink-0" />;
        case ActionGroupType.Completed:
            return <IconCircleCheck size={16} className="shrink-0 text-content-positive" />;
        case ActionGroupType.Failed:
            return <IconCircleX size={16} className="shrink-0 text-content-destructive" />;
        case ActionGroupType.Stopped:
            return <IconStopCircle size={16} className="shrink-0 text-content-strong" />;
        case ActionGroupType.Deleted:
            return <IconTrashCan size={16} className="shrink-0 text-content-destructive" />;
        default:
            return null;
    }
};
